import { Component, Inject, OnInit, OnDestroy } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { UntypedFormGroup, UntypedFormBuilder, Validators, UntypedFormControl } from '@angular/forms';
import { AdminService } from '@admin/services/admin.service';
import { IOption } from '@shared/models/icommons.model';
import { IRecordAccess } from '@shared/models/iuser.model';

@Component({
  selector: 'miq-record-permission-dialog',
  templateUrl: './record-permission-dialog.component.html',
  styleUrls: ['./record-permission-dialog.component.scss'],
  standalone: false,
})
export class RecordPermissionDialogComponent implements OnInit, OnDestroy {
  public searchRecordFC: UntypedFormControl;
  public recordFormGroup: UntypedFormGroup;
  public recordTypeOptions: IOption[];

  constructor(
    private dialogRef: MatDialogRef<RecordPermissionDialogComponent>,
    private formBuilder: UntypedFormBuilder,
    @Inject(MAT_DIALOG_DATA) private data: any,
    private adminService: AdminService
  ) {
    // create search form control.
    this.searchRecordFC = this.formBuilder.control('');
    // crete form group.
    this.recordFormGroup = this.formBuilder.group({
      recordTypeId: ['', Validators.required],
      recordID: ['', Validators.required],
      recordDesc: ['', Validators.required],
    });

    this.adminService.getRecordTypes().subscribe(result => {
      this.recordTypeOptions = result;
    });
  }

  ngOnInit() {
    /* required for static lable translation */
  }

  // form controls getters.
  public get recordTypeId() {
    return this.recordFormGroup.get('recordTypeId');
  }
  public get recordID() {
    return this.recordFormGroup.get('recordID');
  }
  public get recordDesc() {
    return this.recordFormGroup.get('recordDesc');
  }

  /**
   * Search for a record using the the record ID
   * or address as search criteria.
   */
  public searchRecord() {
    /*
     * Functionality not defined yet.
     */
  }

  /**
   * Closes the dialog sending back the record data;
   */
  public addRecord() {
    const recordPermission: IRecordAccess = this.recordFormGroup.value;
    recordPermission.statusId = 1;
    recordPermission.recordTypeVal = this.recordTypeOptions.find(f => f.key === recordPermission.recordTypeId).value;
    this.dialogRef.close(recordPermission);
  }

  /**
   * Close the dialog sanding no data.
   */
  public onCancelClick() {
    this.dialogRef.close();
  }

  ngOnDestroy() {
    /** label translation purpose added */
  }
}
